"use client";

import { ArrowRight, TrainFront as Train, Car, Clock } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceAreas() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const hours = [{
    day: "LUN",
    time: "CON CITA PREVIA",
    active: false
  }, {
    day: "MAR",
    time: "CON CITA PREVIA",
    active: false
  }, {
    day: "MIÉ",
    time: "CON CITA PREVIA",
    active: true
  }, {
    day: "JUE",
    time: "CON CITA PREVIA",
    active: false
  }, {
    day: "VIE",
    time: "CON CITA PREVIA",
    active: false
  }, {
    day: "SÁB",
    time: "CON CITA PREVIA",
    active: false
  }, {
    day: "DOM",
    time: "CON CITA PREVIA",
    active: false
  }];
  const panels = [{
    index: "§ 02 / UBICACIÓN",
    title: "VALENCIA",
    accent: "SERVICIO",
    icon: Train,
    body: "Mi espacio creativo principal se encuentra en el corazón de Valencia. Fácilmente accesible mediante transporte público o privado."
  }, {
    index: "§ 03 / VIAJE",
    title: "MADRID",
    accent: "SERVICIO",
    icon: Car,
    body: "Ofrezco servicios de peluquería y maquillaje a domicilio en todo Madrid para sesiones de modelos profesionales y proyectos editoriales."
  }];
  return <section data-section-id="1893" id="service-areas" ref={sectionRef} className="relative dark bg-background text-foreground py-28 md:py-40 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 h-16 bg-foreground" style={{
      clipPath: "polygon(0 0, 100% 0, 100% 0, 0 100%)"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-[1360px] px-5 md:px-8">
        {}
        <div className={`mb-12 md:mb-16 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-baseline gap-3 mb-4">
            <span className="font-mono text-xs md:text-sm text-primary" style={{
            letterSpacing: "0.22em"
          }}>
              §
            </span>
            <span className="font-mono text-xs md:text-sm text-muted-foreground" style={{
            letterSpacing: "0.22em"
          }}>
              01 / ÁREAS DE SERVICIO
            </span>
            <span className="inline-block h-[4px] w-12 bg-primary ml-2" aria-hidden="true" />
          </div>
          <h2 className="font-default font-bold uppercase text-foreground" style={{
          fontFamily: "var(--font-serif)",
          fontSize: "clamp(3rem, 7.5vw, 7rem)",
          lineHeight: 0.88,
          letterSpacing: "-0.005em"
        }}>
            ENCUENTRA LA <em className="not-italic text-primary italic">ARTISTA</em>
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          {}
          <div className={`lg:col-span-8 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: "80ms"
        }}>
            <div className="relative border-[1.5px] border-foreground/80">
              {}
              <div className="h-1 w-full bg-primary" aria-hidden="true" />

              {}
              <div className="relative" style={{
              minHeight: "640px"
            }}>
                <iframe title="Niki B. Makeup Studio Location" src="https://www.google.com/maps?q=Valencia,Spain&output=embed" className="absolute inset-0 w-full h-full grayscale contrast-125 invert" loading="lazy" referrerPolicy="no-referrer-when-downgrade" style={{
                filter: "invert(0.92) hue-rotate(180deg) contrast(0.9)"
              }} />

                {}
                <div className="absolute top-5 right-5 md:top-6 md:right-6 bg-background border border-border max-w-[280px] z-10">
                  <div className="p-5 md:p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="inline-block h-[4px] w-8 bg-primary" aria-hidden="true" />
                      <span className="font-mono text-[11px] text-primary" style={{
                      letterSpacing: "0.2em"
                    }}>NIKIB.MAKEUP</span>
                    </div>
                    <p className="font-mono text-xs text-foreground mb-4" style={{
                    letterSpacing: "0.16em",
                    lineHeight: 1.5
                  }}>
                      VALENCIA
                      <br />
                      SPAIN
                      <br />
                      BY APPOINTMENT
                    </p>
                    <Link to="/ContactPage" className="inline-flex items-center gap-2 text-primary group">
                      <span className="font-mono text-xs uppercase font-medium border-b-2 border-primary pb-0.5 group-hover:pr-2 transition-all duration-200" style={{
                      letterSpacing: "0.18em"
                    }}><br /></span>
                      
                    </Link>
                  </div>
                </div>

                {}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 pointer-events-none" aria-hidden="true">
                  <div className="relative">
                    <div className="size-14 bg-primary flex items-center justify-center border-2 border-background shadow-lg">
                      <span className="text-primary-foreground font-bold uppercase text-lg" style={{
                      fontFamily: "var(--font-serif)",
                      letterSpacing: "0.05em"
                    }}>
                        NB
                      </span>
                    </div>
                    <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-[8px] border-r-[8px] border-t-[12px] border-l-transparent border-r-transparent border-t-primary" aria-hidden="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-4 flex flex-col">
            {panels.map((panel, i) => {
            const Icon = panel.icon;
            return <div key={i} data-index={i} className={`group relative border-b border-foreground/30 py-7 first:pt-0 pl-5 -ml-5 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: `${160 + i * 80}ms`
            }}>
                  <div className="absolute left-0 top-7 w-[3px] h-0 bg-primary group-hover:h-[calc(100%-3.5rem)] transition-all duration-300 ease-out" />

                  <div className="flex items-center gap-3 mb-3">
                    <Icon className="size-4 text-primary" strokeWidth={1.5} />
                    <span className="font-mono text-[11px]" style={{
                  letterSpacing: "0.22em"
                }}>
                      <span className="text-primary">§</span>{" "}
                      <span className="text-muted-foreground">
                        {panel.index.replace("§ ", "")}
                      </span>
                    </span>
                  </div>

                  <h3 className="font-default font-bold uppercase mb-3 text-foreground" style={{
                fontFamily: "var(--font-serif)",
                fontSize: "clamp(1.75rem, 3vw, 2.25rem)",
                lineHeight: 0.96,
                letterSpacing: "0em"
              }}>
                    {panel.title.replace(panel.accent, "")}
                    <em className="not-italic italic text-primary">{panel.accent}</em>
                  </h3>

                  <p className="font-default text-sm text-muted-foreground" style={{
                lineHeight: 1.55
              }}>
                    {panel.body}
                  </p>
                  <div className="inline-block h-[4px] w-12 bg-primary mt-4" aria-hidden="true" />
                </div>;
          })}

            {}
            <div className={`group relative py-7 pl-5 -ml-5 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            transitionDelay: "320ms"
          }} data-index={2}>
              <div className="absolute left-0 top-7 w-[3px] h-0 bg-primary group-hover:h-[calc(100%-3.5rem)] transition-all duration-300 ease-out" />

              <div className="flex items-center gap-3 mb-3">
                <Clock className="size-4 text-primary" strokeWidth={1.5} />
                <span className="font-mono text-[11px]" style={{
                letterSpacing: "0.22em"
              }}>
                  <span className="text-primary">§</span>{" "}
                  <span className="text-muted-foreground">04 / DISPONIBILIDAD</span>
                </span>
              </div>

              <h3 className="font-default font-bold uppercase mb-5 text-foreground" style={{
              fontFamily: "var(--font-serif)",
              fontSize: "clamp(1.75rem, 3vw, 2.25rem)",
              lineHeight: 0.96
            }}>
                HORARIO DE <em className="not-italic italic text-primary">RESERVAS</em>
              </h3>

              <ul className="space-y-0 border-t border-foreground/20">
                {hours.map((row, idx) => <li data-index={idx} key={row.day} className={`relative flex items-center justify-between py-2.5 border-b border-foreground/20 ${row.active ? "pl-3" : ""}`}>
                    {row.active}
                    <span className="font-mono text-xs text-secondary" style={{
                  letterSpacing: "0.2em"
                }}>
                      {row.day}
                    </span>
                    <span className="font-mono text-xs font-medium text-secondary" style={{
                  letterSpacing: "0.16em"
                }}>
                      {row.time}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-6">
                <Button asChild className="h-14 px-8 bg-primary text-primary-foreground hover:bg-foreground hover:text-background rounded-md font-mono font-medium uppercase text-xs transition-all duration-200 group" style={{
                letterSpacing: "0.18em"
              }}>
                  <Link to="/BookingPage">
                    Reserva Tu Sesión
                    <ArrowRight className="size-4 group-hover:translate-x-1.5 transition-transform duration-200" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}